import type { AuthUser } from '@/types/auth';
import type { Role } from '@/authorization/types';

export function resolveDirectRoles(
  user: AuthUser | null,
  availableRoles: Role[],
): Role[] {
  if (!user) {
    return [];
  }

  const lowerRoleNames = user.roles.map((role) => role.toLowerCase());

  return availableRoles.filter((role) =>
    lowerRoleNames.includes(role.name.toLowerCase()),
  );
}

export function resolveGroupRoles(
  groupRoleNames: string[],
  availableRoles: Role[],
): Role[] {
  const lowerGroupRoles = groupRoleNames.map((role) => role.toLowerCase());

  return availableRoles.filter((role) =>
    lowerGroupRoles.includes(role.name.toLowerCase()),
  );
}
